var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6504,
    y: 29.5713,
    width: 4.5,
    height: 22.5,
    transform: "rotate(-45 13.6504 29.5713)",
    fill: "#1C7E75"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.3066,
    y: 27.4502,
    width: 4.5,
    height: 22.5,
    transform: "rotate(45 43.3066 27.4502)",
    fill: "#1C7E75"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2012,
    width: 4.5,
    height: 42,
    fill: "#1C7E75"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 55.5,
    width: 60,
    height: 4.5,
    fill: "#1C7E75"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 45.75,
    width: 4.5,
    height: 12,
    fill: "#1C7E75"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 45.75,
    width: 4.5,
    height: 12,
    fill: "#1C7E75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.59838e7c38b7d0c988609a6a49af59b6.svg";
export { ForwardRef as ReactComponent };